import('./bootstrap')
  .catch(err => {
    if (err?.name === 'ChunkLoadError' || /Loading chunk [\d]+ failed/.test(err?.message)) {
      window.location.reload();
    } else {
      console.error(err);
    }
  });